var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 95,
    viewBox: "0 0 390 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_2277_2882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390 39.5313L389.849 39.3001C354.7 28.2433 297.212 24.9777 267.689 51.8812C267.689 51.8812 234.005 82.5836 213.441 76.26C213.441 76.26 229.556 94.2445 254.474 73.6315C264.581 65.2693 287.932 40.8904 304.179 45.6426C303.744 45.6143 292.603 56.4682 281.461 74.6744C274.278 86.4155 286.047 99.0674 296.674 93.749C303.815 90.1813 305.52 78.1099 306.809 71.1304C309.171 58.2425 312.576 47.5019 326.49 43.6417C346.166 38.1864 358.838 38.6772 390 39.5313Z",
    fill: "url(#paint0_linear_2277_2882)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.931 22.1653C188.23 9.06509 141.363 26.2284 135.913 28.3001C140.92 26.4125 180.692 12.1419 215.732 24.6239C215.732 24.6239 242.558 39.8241 292.891 11.5473L296.334 8.18262C296.334 8.18262 247.437 36.0913 216.931 22.1653Z",
    fill: "url(#paint1_linear_2277_2882)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.405 90.9605C263.741 100.498 277.267 68.5307 281.324 61.1123C277.853 67.4642 237.92 78.7475 252.405 90.9605Z",
    fill: "url(#paint2_linear_2277_2882)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M235.776 3.9497C228.946 0.584989 215.169 -5.11095 215.429 9.61261C215.859 33.8735 260.397 19.5227 277.588 13.0528C262.654 17.4557 249.926 10.9198 235.776 3.9497Z",
    fill: "url(#paint3_linear_2277_2882)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M277.588 13.0628C279.883 12.3817 282.113 11.4989 284.253 10.4248C284.253 10.4248 281.702 11.5196 277.588 13.0628Z",
    fill: "url(#paint4_linear_2277_2882)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M162.801 28.0128H162.773C156.222 24.8179 152.854 31.1274 156.708 36.8233C165.932 50.4332 174.188 33.6521 162.801 28.0128Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.739 52.3867C247.007 51.3154 245.756 50.9001 244.433 50.9379C241.066 51.0323 237.216 54.0431 240.182 56.6008C243.011 58.9745 250.171 55.9401 247.739 52.3867Z",
    fill: "url(#paint5_linear_2277_2882)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.579 51.4196C243.196 51.2969 239.568 52.7032 241.24 54.5908C243.422 57.0542 249.132 51.8254 244.579 51.4196Z",
    fill: "url(#paint6_linear_2277_2882)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.757 55.3599C243.692 59.39 247.149 54.7275 247.149 54.7275C242.506 57.9412 239.757 55.3599 239.757 55.3599Z",
    fill: "url(#paint7_linear_2277_2882)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.448 12.7844C211.293 12.2719 211.01 11.8076 210.625 11.4358C210.239 11.064 209.765 10.7971 209.247 10.6608C206.541 9.74533 202.592 11.0101 204.217 13.9029C205.752 16.6352 212.336 16.3285 211.448 12.7844Z",
    fill: "url(#paint8_linear_2277_2882)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.219 11.09C208.161 10.5851 204.859 10.6181 205.629 12.6237C206.64 15.2475 212.718 12.7511 209.219 11.09Z",
    fill: "url(#paint9_linear_2277_2882)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.207 12.8027C206.149 17.1679 210.272 14.4733 210.272 14.4733C205.653 15.6625 204.207 12.8027 204.207 12.8027Z",
    fill: "url(#paint10_linear_2277_2882)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.308 35.9543C224.154 35.4418 223.871 34.9775 223.485 34.6057C223.1 34.2339 222.626 33.9671 222.108 33.8308C219.401 32.9153 215.453 34.18 217.078 37.0728C218.608 39.7863 225.192 39.4984 224.308 35.9543Z",
    fill: "url(#paint11_linear_2277_2882)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.079 34.2558C221.017 33.7509 217.72 33.7839 218.49 35.7943C219.5 38.3945 225.588 35.9217 222.079 34.2558Z",
    fill: "url(#paint12_linear_2277_2882)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.087 35.9688C219.028 40.3386 223.151 37.644 223.151 37.644C218.504 38.8427 217.087 35.9688 217.087 35.9688Z",
    fill: "url(#paint13_linear_2277_2882)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.42545 60.2579C-1.54912 63.0894 -1.82307 77.0013 5.76676 75.6327C8.05268 75.2222 9.64433 73.4856 10.5511 71.3006C12.8607 65.7415 10.7448 57.2472 4.42545 60.2579Z",
    fill: "url(#paint14_linear_2277_2882)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.91446 63.4155C1.29411 65.1804 5.65817 78.3137 9.65381 71.1831C10.8629 69.0171 11.2171 62.0706 6.91446 63.4155Z",
    fill: "url(#paint15_linear_2277_2882)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7444 60.3994C-2.7299 63.8727 2.36618 72.9192 2.36618 72.9192C0.514776 63.0374 6.7444 60.3994 6.7444 60.3994Z",
    fill: "url(#paint16_linear_2277_2882)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8701 74.2361C11.576 74.1653 10.5087 74.9062 9.71049 75.9775C7.73629 78.7051 7.78824 83.5894 11.5997 82.7682C15.2317 81.9943 17.1775 74.4721 12.8701 74.2361Z",
    fill: "url(#paint17_linear_2277_2882)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1828 76.1567C9.23817 77.176 8.1566 80.9088 10.6551 80.7295C13.9517 80.4982 13.2763 72.7919 10.1828 76.1567Z",
    fill: "url(#paint18_linear_2277_2882)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3673 76.1523C14.1028 81.7633 10.3716 82.3957 10.3716 82.3957C15.9731 81.7256 14.3673 76.1523 14.3673 76.1523Z",
    fill: "url(#paint19_linear_2277_2882)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3389 47.6344C66.3389 47.6344 92.8396 31.2214 154.385 64.6232C154.385 64.642 91.1629 22.1702 66.3389 47.6344Z",
    fill: "#EDFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2912 74.3113C69.9284 82.2819 77.9339 84.547 84.5036 80.9841C88.5795 78.7756 91.588 74.2311 95.8056 72.1877C122.217 59.4037 149.676 73.6035 163.132 74.1556C163.132 74.1556 86.0244 44.1092 73.2912 74.3113Z",
    fill: "url(#paint20_linear_2277_2882)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2277_2882",
    x1: 193.326,
    y1: 63.4069,
    x2: 367.294,
    y2: 62.9031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#EFF8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E5F4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D5EDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BEE3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A1D7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98D3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2277_2882",
    x1: 140.178,
    y1: 25.0746,
    x2: 296.789,
    y2: 16.9411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20BEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#1DB7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#139CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0B89CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#077DC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001CBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2277_2882",
    x1: 282.516,
    y1: 60.6826,
    x2: 240.47,
    y2: 101.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#EFF8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E5F4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#D5EDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6E6F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2277_2882",
    x1: 217.254,
    y1: 12.2251,
    x2: 277.379,
    y2: 9.10436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20BEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#1DB7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#139CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0B89CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#077DC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001CBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2277_2882",
    x1: 277.706,
    y1: 11.9275,
    x2: 284.311,
    y2: 11.5852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20BEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#1DB7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#139CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0B89CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#077DC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001CBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2277_2882",
    x1: 248.182,
    y1: 51.9561,
    x2: 239.47,
    y2: 56.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BDBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2AD8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#26CEF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#20BEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#17A7DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0C8ACD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001CBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2277_2882",
    x1: 242.612,
    y1: 51.7146,
    x2: 244.577,
    y2: 54.7324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2277_2882",
    x1: 242.473,
    y1: 53.6018,
    x2: 244.583,
    y2: 56.8411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2277_2882",
    x1: 211.243,
    y1: 11.2738,
    x2: 204.399,
    y2: 14.7576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BDBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2AD8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#26CEF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#20BEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#17A7DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0C8ACD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001CBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2277_2882",
    x1: 206.853,
    y1: 10.6799,
    x2: 208.834,
    y2: 13.7214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2277_2882",
    x1: 205.916,
    y1: 11.7066,
    x2: 208.487,
    y2: 15.6539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2277_2882",
    x1: 224.104,
    y1: 34.4421,
    x2: 217.26,
    y2: 37.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BDBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2AD8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#26CEF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#20BEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#17A7DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0C8ACD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001CBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2277_2882",
    x1: 219.714,
    y1: 33.8489,
    x2: 221.695,
    y2: 36.8904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2277_2882",
    x1: 218.777,
    y1: 34.8758,
    x2: 221.348,
    y2: 38.8231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2277_2882",
    x1: 12.5828,
    y1: 64.3013,
    x2: -0.696063,
    y2: 71.0583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BDBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2AD8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#26CEF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#20BEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#17A7DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0C8ACD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001CBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2277_2882",
    x1: 5.11954,
    y1: 64.4593,
    x2: 9.92939,
    y2: 71.8437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2277_2882",
    x1: 2.16326,
    y1: 63.0212,
    x2: 6.76186,
    y2: 70.0812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2277_2882",
    x1: 16.021,
    y1: 76.4325,
    x2: 7.9315,
    y2: 80.5484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BDBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2AD8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#26CEF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#20BEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#17A7DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0C8ACD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001CBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2277_2882",
    x1: 9.76844,
    y1: 76.3026,
    x2: 12.2056,
    y2: 80.0442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2277_2882",
    x1: 11.5349,
    y1: 78.0254,
    x2: 13.552,
    y2: 81.1223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2277_2882",
    x1: 62.2194,
    y1: 71.8199,
    x2: 151.155,
    y2: 71.5645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#EFF8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E5F4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D5EDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BEE3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A1D7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98D3F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2277_2882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 95,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottom);
export default __webpack_public_path__ + "static/media/bottom.63154429e70da0387ace0e677914bf79.svg";
export { ForwardRef as ReactComponent };